import React from "react";
import moment from "moment";
import { IPage } from "../../../../interfaces/models/models/paginated-response.model";
import { IPaginationPayload } from "../../../../interfaces/shared/IPaginationPayload";
import TableActions from "../../../../shared/table/table-actions";
import Button from "../../../../shared/button";
import Table from "../../../../shared/table";

const tableColumns = ["Name", "Last Updated Date", "Actions"];

interface IGuestsTable {
    rows: any[];
    paginationData?: IPage;
    rowsLoading: boolean;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
    onSeeGuestsDetails: (data: any) => void;
    onDeleteRequest: (row: any) => void;
}

const GuestsTable = ({
    rows,
    paginationData,
    rowsLoading,
    setPaginationState,
    onSeeGuestsDetails,
    onDeleteRequest
}: IGuestsTable) => {
    return (
        <Table
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}
            containerStyle="!mt-0"
        >
            {rowsLoading ? (
                <>
                    {[...Array(4)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                                    return (
                                        <td key={j} className="td-1 !min-w-[100%] text-center py-5">
                                            <span></span>
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </>
            ) : (
                <>
                    {rows?.length > 0 &&
                        rows?.map((row, idx: number) => {
                            return (
                                <tr key={idx} className="bg-white border-b hover:bg-gray-50">
                                    <td className="px-5 py-4"><div className="w-20 break-words">{row?.name}</div></td>
                                    <td className="px-5 py-4">{moment(row.updatedAt || row?.createdAt).format('DD/MM/YYYY')}</td>
                                    <td className="px-5 py-4">
                                        <div className="flex flex-row items-center">
                                            <div data-qa='guests-details' onClick={() => onSeeGuestsDetails(row)}>
                                                <img title={'View Details'} alt='guests details' src={'/assets/table-actions/visibility.svg'} className={'min-w-[20px] w-[20px] object-contain cursor-pointer mr-2'} />
                                            </div>
                                            <TableActions>
                                                <div
                                                    onClick={() => onDeleteRequest(row)}
                                                    className='py-2 px-4 cursor-pointer flex flex-row items-center align-flex-start  hover:bg-[#f4f4f4]'
                                                    role='none'>
                                                    <Button
                                                        label={'Delete Info'}
                                                        dataQa={'delete-info'}
                                                        className={`btn-primary-text-underline !no-underline !text-red-600 !font-normal cursor-pointer`}
                                                    />
                                                </div>
                                            </TableActions>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                </>
            )}
        </Table>
    );
};

export default GuestsTable;
